// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Fondo ── */
#bg {
  background-image: url('fondoemail.jpg');
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
}

.content-wrapper {
  position: relative;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
}

/* ── Tarjeta ── */
.result-card {
  background: #fff;
  border-radius: 16px;
  padding: 40px 36px;
  max-width: 460px;
  width: 100%;
  text-align: center;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);
  animation: slideUp 0.5s ease;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ── Logo ── */
.logo-wrapper {
  margin: 0 auto 16px;
  width: 72px;
  height: 72px;
}

.logo-img {
  border-radius: 50%;
  border: 3px solid rgba(208, 29, 23, 0.25);
  display: block;
  width: 72px;
  height: 72px;
}

/* ── Spinner ── */
.spinner-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
}

.spinner {
  width: 80px;
  height: 80px;
  animation: rotateSpin 1.4s linear infinite;
}

.spinner-track {
  stroke: #e8e8e8;
}

.spinner-arc {
  stroke: #d01d17;
  stroke-linecap: round;
  stroke-dasharray: 80;
  stroke-dashoffset: 60;
  animation: dashSpin 1.4s ease-in-out infinite;
}

@keyframes rotateSpin {
  to { transform: rotate(360deg); }
}

@keyframes dashSpin {
  0%   { stroke-dashoffset: 120; }
  50%  { stroke-dashoffset: 30; }
  100% { stroke-dashoffset: 120; }
}

/* ── Textos ── */
.title {
  font-size: 1.8rem;
  font-weight: 800;
  color: #391410;
  margin: 0 0 6px;
}

.subtitle {
  font-size: 0.95rem;
  color: #666;
  margin: 0 0 20px;
}

/* ── Divisor ── */
.divider {
  height: 3px;
  background: linear-gradient(90deg, #d01d17, #391410);
  border-radius: 4px;
  margin: 0 auto 20px;
  width: 60px;
}

/* ── Filas de info ── */
.info-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.85rem;
  color: #555;
  padding: 9px 12px;
  border-radius: 8px;
  background: #f9f9f9;
  margin-bottom: 8px;
  text-align: left;
}

.info-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}

/* ── Caja de aviso ── */
.advice-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  background: #fffbf0;
  border: 1px solid #f5e4a0;
  border-radius: 10px;
  padding: 14px 16px;
  margin-top: 16px;
  text-align: left;
}

.advice-icon {
  font-size: 1.2rem;
  flex-shrink: 0;
}

.advice-box p {
  font-size: 0.85rem;
  color: #666;
  margin: 0;
  line-height: 1.6;
}

/* ── Responsive ── */
@media (max-width: 500px) {
  .result-card { padding: 28px 20px; }
  .title { font-size: 1.5rem; }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/pagorespuesta3ds2/pagorespuesta3ds2.component.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,uCAA8D;EAC9D,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,qBAAqB,EAAE;EAC9B,OAAO,sBAAsB,EAAE;AACjC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,oDAAoD;EACpD,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,eAAe,kBAAkB,EAAE;EACnC,SAAS,iBAAiB,EAAE;AAC9B","sourcesContent":["/* ── Fondo ── */\n#bg {\n  background-image: url('../../../assets/images/fondoemail.jpg');\n  min-height: 100vh;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.content-wrapper {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 24px 16px;\n}\n\n/* ── Tarjeta ── */\n.result-card {\n  background: #fff;\n  border-radius: 16px;\n  padding: 40px 36px;\n  max-width: 460px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.35);\n  animation: slideUp 0.5s ease;\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ── Logo ── */\n.logo-wrapper {\n  margin: 0 auto 16px;\n  width: 72px;\n  height: 72px;\n}\n\n.logo-img {\n  border-radius: 50%;\n  border: 3px solid rgba(208, 29, 23, 0.25);\n  display: block;\n  width: 72px;\n  height: 72px;\n}\n\n/* ── Spinner ── */\n.spinner-wrapper {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 20px;\n}\n\n.spinner {\n  width: 80px;\n  height: 80px;\n  animation: rotateSpin 1.4s linear infinite;\n}\n\n.spinner-track {\n  stroke: #e8e8e8;\n}\n\n.spinner-arc {\n  stroke: #d01d17;\n  stroke-linecap: round;\n  stroke-dasharray: 80;\n  stroke-dashoffset: 60;\n  animation: dashSpin 1.4s ease-in-out infinite;\n}\n\n@keyframes rotateSpin {\n  to { transform: rotate(360deg); }\n}\n\n@keyframes dashSpin {\n  0%   { stroke-dashoffset: 120; }\n  50%  { stroke-dashoffset: 30; }\n  100% { stroke-dashoffset: 120; }\n}\n\n/* ── Textos ── */\n.title {\n  font-size: 1.8rem;\n  font-weight: 800;\n  color: #391410;\n  margin: 0 0 6px;\n}\n\n.subtitle {\n  font-size: 0.95rem;\n  color: #666;\n  margin: 0 0 20px;\n}\n\n/* ── Divisor ── */\n.divider {\n  height: 3px;\n  background: linear-gradient(90deg, #d01d17, #391410);\n  border-radius: 4px;\n  margin: 0 auto 20px;\n  width: 60px;\n}\n\n/* ── Filas de info ── */\n.info-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.85rem;\n  color: #555;\n  padding: 9px 12px;\n  border-radius: 8px;\n  background: #f9f9f9;\n  margin-bottom: 8px;\n  text-align: left;\n}\n\n.info-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n/* ── Caja de aviso ── */\n.advice-box {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  background: #fffbf0;\n  border: 1px solid #f5e4a0;\n  border-radius: 10px;\n  padding: 14px 16px;\n  margin-top: 16px;\n  text-align: left;\n}\n\n.advice-icon {\n  font-size: 1.2rem;\n  flex-shrink: 0;\n}\n\n.advice-box p {\n  font-size: 0.85rem;\n  color: #666;\n  margin: 0;\n  line-height: 1.6;\n}\n\n/* ── Responsive ── */\n@media (max-width: 500px) {\n  .result-card { padding: 28px 20px; }\n  .title { font-size: 1.5rem; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
